<div>
    <app-pop-up-info-header [mainTitle]="projetName" [subTitle]="subTitle" [displayLogos]="false" (closed)="close()">
    </app-pop-up-info-header>
    <div>
        <app-pop-up-info-properties [datas]="data" [verticalProperties]="verticalProperties" [keepOriginalOrder]="true">
        </app-pop-up-info-properties>
    </div>
</div>